import { render } from "./BaseTicketCard.vue?vue&type=template&id=3a2f4e87"
import script from "./BaseTicketCard.vue?vue&type=script&lang=js"
export * from "./BaseTicketCard.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "3a2f4e87"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a2f4e87', script)) {
    api.reload('3a2f4e87', script)
  }
  
  module.hot.accept("./BaseTicketCard.vue?vue&type=template&id=3a2f4e87", () => {
    api.rerender('3a2f4e87', render)
  })

}

script.__file = "src/ui/tickets/BaseTicketCard.vue"

export default script